export default __webpack_public_path__ + "static/media/backhand-index-pointing-down.6763ab4c.png";